'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPhonelinkErase = function CommunicationPhonelinkErase(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
  );
};
CommunicationPhonelinkErase = (0, _pure2.default)(CommunicationPhonelinkErase);
CommunicationPhonelinkErase.displayName = 'CommunicationPhonelinkErase';

exports.default = CommunicationPhonelinkErase;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/communication/phonelink-erase.js
 ** module id = 1278
 ** module chunks = 0
 **/